import React from 'react';
import { AuthLayout } from '../../../components/layout/Layouts'; 
import Attendance from '../../../components/Dashboard/Attendance'; 

const AttendancePage = () => {
  return (
    <AuthLayout>
      <Attendance />
    </AuthLayout>
  );
};

export default AttendancePage;
